import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const ChatbotFAB = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [conversation, setConversation] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const chatEndRef = useRef(null);

  const toggleChat = () => setIsOpen(!isOpen);

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [conversation, isTyping]);

  const sendMessage = async () => {
    if (!message.trim()) return;

    const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    const userMessage = { sender: "user", text: message, time: timestamp };
    setConversation((prev) => [...prev, userMessage]);
    setIsTyping(true);
    setMessage("");

    try {
      const res = await axios.post("https://mnkymn9n.pythonanywhere.com/api/chat", { message });

      setTimeout(() => {
        const botMessage = {
          sender: "bot",
          text: res.data.response,
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        };
        setConversation((prev) => [...prev, botMessage]);
        setIsTyping(false);
      }, 800); // simulate typing delay
    } catch (err) {
      setConversation((prev) => [
        ...prev,
        {
          sender: "bot",
          text: "⚠️ Sorry, something went wrong.",
          time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        },
      ]);
      setIsTyping(false);
    }
  };

  return (
    <div>
      {/* Floating Button */}
      <button
        onClick={toggleChat}
        className="btn btn-primary"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          fontSize: "20px",
          zIndex: 999,
        }}
      >
        💬
      </button>

      {/* Chat Box */}
      {isOpen && (
        <div
          className="card shadow"
          style={{
            position: "fixed",
            bottom: "90px",
            right: "20px",
            width: "90%",
            maxWidth: "350px",
            maxHeight: "500px",
            display: "flex",
            flexDirection: "column",
            zIndex: 1000,
          }}
        >
          <div className="card-header bg-primary text-white p-2">
            <strong>Chat with us</strong>
            <button
              onClick={toggleChat}
              className="btn btn-sm btn-light float-end"
            >
              ✖
            </button>
          </div>

          <div
            className="card-body d-flex flex-column overflow-auto"
            style={{ flex: 1, fontSize: "14px", wordWrap: "break-word" }}
          >
            {conversation.map((msg, i) => (
              <div
                key={i}
                className={`d-flex flex-column ${
                  msg.sender === "user" ? "align-items-end" : "align-items-start"
                } mb-2`}
              >
                <div
                  className={`p-2 rounded text-white ${
                    msg.sender === "user" ? "bg-info" : "bg-secondary"
                  }`}
                  style={{
                    maxWidth: "80%",
                    wordBreak: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {msg.text}
                </div>
                <small className="text-muted">{msg.time}</small>
              </div>
            ))}

            {isTyping && (
              <div className="d-flex align-items-start mb-2">
                <div
                  className="bg-secondary text-white p-2 rounded"
                  style={{ maxWidth: "60%" }}
                >
                  <em>Typing...</em>
                </div>
              </div>
            )}
            <div ref={chatEndRef} />
          </div>

          <div className="card-footer d-flex p-2">
            <input
              type="text"
              className="form-control me-1"
              value={message}
              placeholder="Type a message..."
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button className="btn btn-success" onClick={sendMessage}>
              ➤
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatbotFAB;
